import { MobXProviderContext } from 'mobx-react';
import React, { useState, useEffect, useContext } from 'react';
import { ROLE_TYPE_RESIDENT } from '../../../constants/RegisterConstants';

export const AsyncProfileImageInDataTableRow = (props) => {
  const [asyncData, setAsyncData] = useState(null);
  const [loading, setLoading] = useState(true);
  const { backendAPIStore } = useContext(MobXProviderContext);
  const roleType = props.roleType;
  const [imageSize, setImageSize] = useState(props.imageSize || 50);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      let url;

      try {
        if (roleType === ROLE_TYPE_RESIDENT) {
          url = await backendAPIStore.handlePresignedUrlForDownloadResidentPic(
            props.userId
          );
        } else {
          url = await backendAPIStore.getPresignedUrlForProfilePicDownload(
            props.userId,
          );
        }
        if (props.imageSize) {
          setImageSize(props.imageSize);
        }
      } catch (error) {
        console.error("Error fetching profile image URL:", error);
      }

      setAsyncData(url);
      setLoading(false);
    };

    fetchData();
  }, [props.userId]);

  if (loading) {
    return <div>Loading...</div>;
  }

  return <div>
    {
      asyncData ? (
        <img src={asyncData!} alt="Profile" width={imageSize} height={imageSize} style={{ borderRadius: '50%' }} />
      ) : null
    }
  </div>;
};
